export default __webpack_public_path__ + "images/icons/iksoris-logo-light.svg";